module.exports = __webpack_public_path__ + "static/lake_aerial_6-34b7dcd025372a3f830b0dad641d2655.jpg";